import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import Button from "@shared/v2/Button";

const ConfirmLeaveModal = ({ blocker }) => (
  <Modal
    show={blocker.state === "blocked"}
    onHide={blocker.reset}
    closeOnEscape={false}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Confirm Leave" />
    <Modal.Body>
      <Typography variant="body-m">Are you sure you want to cancel creating your new page?</Typography>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
      <Button size="medium" schema="tertiary" onClick={blocker.reset}>
        Close
      </Button>
      <Button size="medium" schema="warning" onClick={blocker.proceed}>
        Yes, Cancel
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmLeaveModal.propTypes = {
  blocker: PropTypes.shape().isRequired,
};

export default ConfirmLeaveModal;
